export const initHeader = () => {
  const header = document.querySelector('.header');

  if (!header) {
    return;
  }

  const hidePos = 70; // in px;
  let prevScrollYPos = 0; // in px;

  const headerScrollHandler = () => {
    if (window.scrollY === 0) {
      header.classList.remove('hide');
    } else if (window.scrollY > hidePos) {
      if (window.scrollY < prevScrollYPos) {
        header.classList.remove('hide');
      } else {
        header.classList.add('hide');
      }
    }

    prevScrollYPos = window.scrollY;
  };

  headerScrollHandler();
  window.addEventListener('scroll', headerScrollHandler);

  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        header.classList.remove('header--scrolled');
      } else {
        header.classList.add('header--scrolled');
      }
    });
  };

  const mutationObserverOptions = {
    attributes: true,
    childList: true,
    subtree: true
  };

  const setHeaderPosition = (announcmentBarHeight = 0) => {
    let topPosition = announcmentBarHeight + 10;
    header.style.setProperty('--topPosition', `${topPosition}px`);
  };

  const announcmentBarMutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.id == 'announcement-bar-root') {
        let announcmentBarHeight = Math.floor(
          document.querySelector('#announcement-bar-root').getBoundingClientRect().height
        );

        setHeaderPosition(announcmentBarHeight);

        announcmentBarMutationObserver.disconnect();

        window.addEventListener('scroll', () => {
          if (window.scrollY >= announcmentBarHeight) {
            setHeaderPosition();
          } else {
            setHeaderPosition(announcmentBarHeight);
          }
        });
      }
    });
  });

  setHeaderPosition();
  announcmentBarMutationObserver.observe(document.body, mutationObserverOptions);

  const createObserver = (boxElement) => {
    let options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    let observer = new IntersectionObserver(handleIntersection, options);
    observer.observe(boxElement);
  };

  window.addEventListener(
    'load',
    () => {
      const observeHeroSection = document.querySelector('.hero');

      if (observeHeroSection) {
        createObserver(observeHeroSection);
      }
    },
    false
  );
};
